'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _typeahead = require('../typeahead');

var _typeahead2 = _interopRequireDefault(_typeahead);

var _addClass = require('../../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _makeElement = require('../../helpers/dom/make-element');

var _makeElement2 = _interopRequireDefault(_makeElement);

var _assign = require('../../helpers/polyfill/assign');

var _assign2 = _interopRequireDefault(_assign);

var _repeat = require('../../helpers/polyfill/repeat');

var _repeat2 = _interopRequireDefault(_repeat);

var _startsWith = require('../../helpers/polyfill/starts-with');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _each = require('../../helpers/util/each');

var _each2 = _interopRequireDefault(_each);

var _isInteger = require('../../helpers/util/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _mixin = require('../../helpers/util/mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var _messaging = require('../../mixins/messaging');

var _messaging2 = _interopRequireDefault(_messaging);

var _validation = require('../../mixins/validation');

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Card Number Input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * An input container for card number payment details.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Spark.Payments.CardNumber(el, {...});
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/payments.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var onCardTypeEvent = document.createEvent('Event');
var onValidEvent = document.createEvent('Event');
var onInvalidEvent = document.createEvent('Event');

onCardTypeEvent.initEvent('type', true, true);
onValidEvent.initEvent('valid', true, true);
onInvalidEvent.initEvent('invalid', true, true);

var cardDefaults = {
  amex: {
    name: 'American Express',
    length: 15,
    cvv: 4,
    prefix: [34, 37],
    pattern: [4, 6, 5]
  },
  china: {
    name: 'China UnionPay',
    length: [16, 19],
    cvv: 3,
    prefix: 62,
    pattern: [[4, 4, 4, 4], [6, 13]]
  },
  discover: {
    name: 'Discover',
    length: 16,
    cvv: 3,
    prefix: [6011, [622126, 622925], [644, 649], 65],
    pattern: [4, 4, 4, 4]
  },
  jcb: {
    name: 'JCB',
    length: 16,
    cvv: 3,
    prefix: [[3528, 3589]],
    pattern: [4, 4, 4, 4]
  },
  mc: {
    name: 'MasterCard',
    length: 16,
    cvv: 3,
    prefix: [[51, 55]],
    pattern: [4, 4, 4, 4]
  },
  uatp: {
    name: 'UATP',
    length: 15,
    cvv: 3,
    prefix: 1,
    pattern: [4, 5, 6]
  },
  dc: {
    name: 'Diners Club International',
    length: 14,
    cvv: 3,
    prefix: [[300, 305], 309, 36, [38, 39]],
    pattern: [4, 6, 4]
  },
  visa: {
    name: 'Visa',
    length: [16, 19],
    cvv: 3,
    prefix: [4, 4026, 417500, 4405, 4508, 4844, 4913, 4917],
    pattern: [[4, 4, 4, 4], [6, 4, 8, 1]]
  }
};

var unflipCard = function unflipCard() {
  this.el.dataset.cardType = this.type;
  this.multiPattern = false;
  this.type = '';
  this._initTypeAhead();
};

var CardNumber = function (_BaseComponent) {
  _inherits(CardNumber, _BaseComponent);

  /**
   * CardNumber constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function CardNumber(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, CardNumber);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    _this._initTypeAhead();
    return _this;
  }

  /**
   * Parse parameters from the elements.
   *
   */


  CardNumber.prototype._parseParams = function _parseParams() {
    if (this.disableCardDefaults) {
      var disabledDefaults = this.disableCardDefaults;
      var enabledDefaults = {};
      var defaults = Object.keys(cardDefaults).filter(function (config) {
        return !disabledDefaults.some(function (disabled) {
          return disabled === config;
        });
      });
      (0, _each2.default)(defaults, function (config) {
        return enabledDefaults[config] = (0, _assign2.default)({}, cardDefaults[config]);
      });
      this._cardTypes = (0, _assign2.default)(enabledDefaults, this.cardTypes || {});
    } else {
      this._cardTypes = (0, _assign2.default)(cardDefaults, this.cardTypes || {});
    }
  };

  /**
   * Sets up references
   * @param {Element} el base DOM element
   */


  CardNumber.prototype._cacheElements = function _cacheElements(el) {
    this.el = el;
    this.inputEl = el.querySelector('input');

    if (this.inputEl.value) {
      (0, _addClass2.default)(this.el, 'active');
    }

    this.messageEl = this.el.querySelector('.spark-input__message') || (0, _makeElement2.default)('<span class="spark-input__message"></span>');
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  CardNumber.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onInputBound = this._onInput.bind(this);
    this._onCardTypeBound = this._onCardType.bind(this);
    this._onBlurBound = this._onBlur.bind(this);
    this._onFocusBound = this._onFocus.bind(this);
    this._onInvalidBound = this._onInvalid.bind(this);
    this._onValidBound = this._onValid.bind(this);
  };

  /**
   * Add event listeners for DOM events.
   */


  CardNumber.prototype._addEventListeners = function _addEventListeners() {
    this.inputEl.addEventListener('input', this._onInputBound, false);
    this.inputEl.addEventListener('type', this._onCardTypeBound, false);
    this.inputEl.addEventListener('blur', this._onBlurBound, false);
    this.inputEl.addEventListener('focus', this._onFocusBound, false);
    this.inputEl.addEventListener('invalid', this._onInvalidBound, false);
    this.inputEl.addEventListener('valid', this._onValidBound, false);
  };

  /**
   * Remove event listeners for DOM events..
   */


  CardNumber.prototype._removeEventListeners = function _removeEventListeners() {
    this.inputEl.removeEventListener('input', this._onInputBound, false);
    this.inputEl.removeEventListener('type', this._onCardTypeBound, false);
    this.inputEl.removeEventListener('blur', this._onBlurBound, false);
    this.inputEl.removeEventListener('focus', this._onFocusBound, false);
    this.inputEl.removeEventListener('invalid', this._onInvalidBound, false);
    this.inputEl.removeEventListener('valid', this._onValidBound, false);
  };

  /**
   * onInvalid method for firing provided callbacks
   */


  CardNumber.prototype._onInvalid = function _onInvalid() {
    this.onInvalid.call(this);
  };

  /**
   * onValid method for firing provided callbacks
   */


  CardNumber.prototype._onValid = function _onValid() {
    this.onValid.call(this);
  };

  /**
   * onBlur callback, for controlling component active state, firing provided callbacks, and running validation
   */


  CardNumber.prototype._onBlur = function _onBlur() {
    if (!this.inputEl.value) {
      (0, _removeClass2.default)(this.el, 'active');
    }

    this.onBlur.call(this);

    if (this.inputEl.hasAttribute('data-novalidate')) {
      this.inputEl.removeAttribute('data-novalidate');
    }

    if (!this.valid) {
      this.inputEl.dispatchEvent(onInvalidEvent);
    }
  };

  /**
   * onFocus callback, for controlling component active state and firing provided callbacks
   */


  CardNumber.prototype._onFocus = function _onFocus() {
    (0, _addClass2.default)(this.el, 'active');
    this.onFocus.call(this);
  };

  /**
   * onCardType callback for controlling the displayed card type once a matching pattern has been recognized
   */


  CardNumber.prototype._onCardType = function _onCardType() {
    if (this.type) {
      var cardType = this._cardTypes[this.type];
      this.multiPattern = cardType.pattern.some(function (patternValue) {
        return Array.isArray(patternValue);
      });

      if (this.activePattern !== this.previousPattern) {
        this._initTypeAhead();
      }
    } else {
      this.multiPattern = false;
    }

    this.onCardType.call(this);
  };

  /**
   * Updates typeahead based on cardtype
   */


  CardNumber.prototype._initTypeAhead = function _initTypeAhead() {
    var patternIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (this.inputEl && this.type) {
      var cardType = this._cardTypes[this.type];
      var pattern = this.multiPattern ? cardType.pattern[patternIndex] : cardType.pattern;
      var regexPattern = pattern.map(function (digits) {
        return (0, _repeat2.default)('\\d', digits);
      }).join(' ');

      this.inputEl.setAttribute('placeholder', pattern.slice(0).map(function (digits) {
        return (0, _repeat2.default)('0', digits);
      }).join(' '));
      this.inputEl.dataset.typeaheadFormat = regexPattern;

      if (this.multiPattern && patternIndex === 0) {
        this.inputEl.setAttribute('minlength', this.inputEl.placeholder.length);
        this.inputEl.setAttribute('maxlength', this.inputEl.placeholder.length + 4);
        this.inputEl.dataset.typeaheadFormat += ' \\d\\d\\d';
      } else {
        this.inputEl.setAttribute('minlength', this.inputEl.placeholder.length);
        this.inputEl.setAttribute('maxlength', this.inputEl.placeholder.length);
      }

      if (!this.multiPattern) {
        this.inputEl.setAttribute('pattern', regexPattern);
      } else if (patternIndex > 0) {
        this.inputEl.setAttribute('pattern', '(\\d\\s?){' + cardType.length[patternIndex] + '}');
      } else {
        this.inputEl.setAttribute('pattern', regexPattern + '\\s?');
      }

      if (this.typeahead) {
        this.typeahead.remove(true);

        var placeholderEl = this.el.querySelector('.spark-input__placeholder');
        placeholderEl.parentNode.removeChild(placeholderEl);
      }

      this.typeahead = new _typeahead2.default(this.el);
    } else if (this.inputEl) {
      this.multiPattern = false;
      this.inputEl.setAttribute('placeholder', '0000 0000 0000 0000');
      this.inputEl.setAttribute('minlength', this.inputEl.placeholder.length);
      this.inputEl.setAttribute('maxlength', this.inputEl.placeholder.length);
      this.inputEl.setAttribute('pattern', '\\d\\d\\d\\d ?\\d\\d\\d\\d ?\\d\\d\\d\\d ?\\d\\d\\d\\d');
      this.inputEl.dataset.typeaheadFormat = '\\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d';
      if (this.typeahead) {
        this.typeahead.format = this.typeahead._parseFormat('\\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d');
        this.typeahead.updateValue();
        this.typeahead.run();
      } else {
        this.typeahead = new _typeahead2.default(this.el);
      }
    }
  };

  /**
   * onInput callback, for controlling component active state, firing provided callbacks, running validation,
   * determining the card type, and formatting the display
   */


  CardNumber.prototype._onInput = function _onInput() {
    if (this.value) {
      (0, _addClass2.default)(this.el, 'active');

      // Get compiled card type definition codes
      var cardTypes = Object.keys(this._cardTypes);

      var cardTypeMatched = false;

      // loop over card type codes to pull type data and compare to value
      (0, _each2.default)(cardTypes, function (type) {

        // single card type data from card types for type code
        var cardType = this._cardTypes[type];

        // check if card type has single prefix or multiple (is array or number)
        if ((0, _isInteger2.default)(cardType.prefix)) {

          // card type has only one prefix, proceed to check if it's equivilent to the current value prefix
          if ((0, _startsWith2.default)(this.value, cardType.prefix.toString())) {

            // card type prefix matches value prefix, so update type if changed
            if (type !== this.type) {
              this.type = type;
            }

            cardTypeMatched = true;

            // return to break out loop, since match was found
            return;
          } else {
            // card type has multiple prefixes (array)

            // loop through prefixes to check for a match
            (0, _each2.default)(cardType.prefix, function (prefix) {

              // check whether prefix is fixed (number) or a range (array w/ start/end)
              if ((0, _isInteger2.default)(prefix)) {

                // prefix is fixed, so check for match
                if ((0, _startsWith2.default)(this.value, prefix.toString())) {

                  // card type prefix matches value prefix, so update type if changed
                  if (type !== this.type) {
                    this.type = type;
                  }

                  cardTypeMatched = true;

                  // return to break out loop, since match was found
                  return;
                }
              } else {
                // prefix is a range, so check whether or not value prefix is within range

                // sample a prefix from current value of equal length in figures to range for comparison
                var prefixRangeLength = prefix[0].toString().length;
                var valuePrefixSample = this.value.substr(0, prefixRangeLength);

                // return now if value prefix is less figures than range, because it's not possible to match
                if (valuePrefixSample.length < prefixRangeLength) {
                  return;
                } else {
                  // check if the prefix is within the range
                  if (valuePrefixSample >= prefix[0] && valuePrefixSample <= prefix[1]) {

                    // value prefix is within card type prefix range, so update type if changed
                    if (type !== this.type) {
                      this.type = type;
                    }

                    cardTypeMatched = true;

                    // return to break out loop, since match was found
                    return;
                  }
                }
              }
            }.bind(this));
          }
        } else {
          // card type has multiple possible prefixes, so loop through them
          (0, _each2.default)(cardType.prefix, function (prefixVariant) {

            // check whether prefix is fixed (number) or a range (array w/ start/end)
            if ((0, _isInteger2.default)(prefixVariant)) {

              // prefix is fixed, so check for match
              if ((0, _startsWith2.default)(this.value, prefixVariant.toString())) {

                // card type prefix matches value prefix, so update type if changed
                if (type !== this.type) {
                  this.type = type;
                }

                cardTypeMatched = true;

                // return to break out loop, since match was found
                return;
              }
            } else {
              // prefix is a range, so check whether or not value prefix is within range

              // sample a prefix from current value of equal length in figures to range for comparison
              var prefixRangeLength = prefixVariant[0].toString().length;
              var valuePrefixSample = this.value.substr(0, prefixRangeLength);

              // return now if value prefix is less figures than range, because it's not possible to match
              if (valuePrefixSample.length < prefixRangeLength) {
                return;
              } else {
                // check if the prefix is within the range
                if (valuePrefixSample >= prefixVariant[0] && valuePrefixSample <= prefixVariant[1]) {

                  // value prefix is within card type prefix range, so update type if changed
                  if (type !== this.type) {
                    this.type = type;
                  }

                  cardTypeMatched = true;

                  // return to break out loop, since match was found
                  return;
                }
              }
            }
          }.bind(this));
        }
      }.bind(this));

      // if no type was matched, make sure we're not showing a card logo
      if (!cardTypeMatched || !this.type && this.el.dataset.cardType) {
        unflipCard.call(this);
      }
    } else {
      // no current value

      if (this.el.dataset.cardType) {
        // if there was a previous card type match, clear it, because there's no longer a value
        unflipCard.call(this);
        this.type = '';
        this.el.removeAttribute('data-card-type');
      }
    }

    // Switch to higher digit pattern if necessecary
    if (this.multiPattern) {
      this._cardTypes[this.type].length.forEach(function (length, index, lengths) {
        var currentValue = this.value;
        if (currentValue.length === length) {
          this._initTypeAhead(index);
          this.typeahead.setValue(currentValue);
        } else if (currentValue.length > length && lengths[index + 1]) {
          this._initTypeAhead(index + 1);
          this.typeahead.setValue(currentValue);
        } else if (index > 0 && currentValue.length < lengths[index - 1]) {
          this._initTypeAhead(index - 1);
          this.typeahead.setValue(currentValue);
        }
      }, this);
    }

    // trigger callback
    this.onInput.call(this);

    this._checkValidity();
  };

  /**
   * Triggers validity events
   */


  CardNumber.prototype._checkValidity = function _checkValidity() {
    if (!this.inputEl.hasAttribute('data-novalidate')) {
      this.inputEl.dispatchEvent(this.valid ? onValidEvent : onInvalidEvent);
    }
  };

  /**
   * Getter that returns the currently recognized card type code
   * @return {String}
   */


  /**
   * Method for triggering focus on component's input element from outside of component
   */
  CardNumber.prototype.focus = function focus() {
    this.inputEl.focus();
  };

  /**
   * Default validate function. This can be overridden by passing a
   * custom validate method as a parameter.
   */


  CardNumber.prototype.validate = function validate() {
    if (this.validatePattern) {
      this.inputEl.setAttribute('pattern', this.validatePattern);
    }

    if (typeof this.onValidate === 'function') {
      this.onValidate(this.valid, this.value, this);
    }

    return this;
  };

  /**
   * Show the input by adding the active state and setting character counts (if necessary).
   */


  CardNumber.prototype.show = function show() {
    (0, _addClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Hide the input by removing the active state.
   */


  CardNumber.prototype.hide = function hide() {
    (0, _removeClass2.default)(this.el, 'active');
    return this;
  };

  /**
   * Set the value of the input.
   * @param {Mixed} value
   */


  CardNumber.prototype.setValue = function setValue(value) {
    this.value = value;

    if (value) {
      this.show();
    } else {
      this.hide();
    }

    return this;
  };

  /**
   * Get the value of the input.
   * @return {String}
   */


  CardNumber.prototype.getValue = function getValue() {
    return this.value;
  };

  /**
   * Clear the value of the input.
   */


  CardNumber.prototype.clearValue = function clearValue() {
    this.value = '';
    return this;
  };

  /**
   * Disable the input.
   */


  CardNumber.prototype.disable = function disable() {
    this.inputEl.attributes.setNamedItem(document.createAttribute('disabled'));
    return this;
  };

  /**
   * Enable the input.
   */


  CardNumber.prototype.enable = function enable() {
    this.inputEl.removeAttribute('disabled');
    return this;
  };

  /**
   * Remove component from DOM.
   * @param {Boolean} leaveElement
   */


  CardNumber.prototype.remove = function remove(leaveElement) {
    return _BaseComponent.prototype.remove.call(this, leaveElement);
  };

  /**
   * Update the element in use and the position.
   * @param {Element} el
   */


  CardNumber.prototype.update = function update(el) {
    return _BaseComponent.prototype.update.call(this, el);
  };

  _createClass(CardNumber, [{
    key: 'type',
    get: function get() {
      if (this.activeCardType) {
        return this.activeCardType;
      }
      return undefined;
    }

    /**
     * Setter for changing the currently recognized card type code, and updating the card type graphic
     */
    ,
    set: function set(cardType) {
      if (cardType && cardType !== this.activeCardType) {
        this.previousPattern = this.activePattern;
        this.activePattern = this._cardTypes[cardType].pattern;
        this.activeCardType = cardType;
        this.el.dataset.cardType = 'cc-' + cardType;

        if (this.inputEl) {
          this.inputEl.dispatchEvent(onCardTypeEvent);
        }
      } else if (!cardType) {
        this.previousPattern = this.activePattern;
        this.activePattern = undefined;
        this.activeCardType = '';
        this.multiPattern = false;
      }
    }

    /**
     * Getter for Primary Component Value
     * @return {String}
     */

  }, {
    key: 'value',
    get: function get() {
      return this.inputEl.value.replace(/\D/g, '');
    }

    /**
     * Setter for Primary Component Value
     * @param {Number} val
     */
    ,
    set: function set(val) {
      if (this.typeahead) {
        this.typeahead.setValue(val);
      } else {
        this.inputEl.value = val;
      }
    }

    /**
     * Getter for Valid state, returns true if component value is valid, false if not
     * Runs Luhn Algorithm
     * @return {Boolean}
     */

  }, {
    key: 'valid',
    get: function get() {

      var value = this.value;
      if (/[^0-9-\s]+/.test(value)) return false;
      var nCheck = 0;
      var nDigit = 0;
      var bEven = false;
      value = value.replace(/\D/g, "");

      for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n);
        nDigit = parseInt(cDigit, 10);

        if (bEven) {
          if ((nDigit *= 2) > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
      }

      var input = this.inputEl;
      var format = new RegExp(input.getAttribute('pattern'));
      return input.willValidate && input.value.length >= input.getAttribute('minlength') && format.test(input.value) && nCheck % 10 === 0;
    }
  }]);

  return CardNumber;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


CardNumber.prototype._whitelistedParams = ['cardTypes', 'disableCardDefaults', 'onInput', 'onBlur', 'onFocus', 'onValidate', 'validate', 'validatePattern', 'onInvalid', 'onValid', 'onCardType'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
CardNumber.prototype.defaults = {
  el: null,
  inputEl: null,
  type: null,
  cardTypes: null,
  disableCardDefaults: null,
  validatePattern: null,
  onInput: function onInput() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onValidate: function onValidate() {},
  onInvalid: function onInvalid() {},
  onValid: function onValid() {},
  onCardType: function onCardType() {}
};

(0, _mixin2.default)(CardNumber.prototype, _messaging2.default, _validation2.default);

exports.default = CardNumber;
module.exports = exports['default'];
//# sourceMappingURL=card-number.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/components/payments/card-number.js
// module id = 399
// module chunks = 0